import { useRef, useState } from "react";
import styled, { css } from "styled-components";
import ModalProduct from "components/templates/project/Scene/ModalProduct";
import PinType from "types/Pin";
import { ReactComponent as IconPin } from "assets/images/common/pin.svg";

interface Props {
  pin: PinType;
  pinId: number;
  productId: number;
  onClickPin: () => void;
}

// 샘플적용 버튼 클릭 시 생성되는 핀 컴포넌트
const Pin = ({ pin, onClickPin, productId, pinId }: Props) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [show, setShow] = useState(false);

  const top = Number(pin.yCoordinate);
  const modalHeight = document.body.clientHeight - top - 160;

  return (
    <Container left={pin.xCoordinate} top={pin.yCoordinate}>
      <BtnPin ref={buttonRef} onClick={onClickPin} active={pin.id === pinId}>
        <IconPin />
      </BtnPin>
      {/* {show && (
        <ModalProduct
          onClose={() => setShow(false)}
          height={modalHeight}
          pinId={pin.id}
        />
      )} */}
    </Container>
  );
};

const Container = styled.div<{ left: string; top: string }>`
  position: absolute;
  left: calc(${({ left }) => `${left}% - 20px`});
  top: calc(${({ top }) => `${top}% - 20px`});
`;

const BtnPin = styled.button<{ active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  outline: 4px solid rgba(255, 255, 255, 0.2);
  border: 5px solid rgba(255, 255, 255, 0.5);
  box-shadow: 5px 5px 30px rgba(0, 0, 0, 0.2);

  & > svg {
    position: relative;
    z-index: 2;
  }

  &::after {
    position: absolute;
    z-index: 1;
    content: "";
    display: block;
    width: 30px;
    height: 30px;
    background-color: #fff;
    border-radius: 100%;
  }

  ${({ active }) =>
    active &&
    css`
      path {
        fill: #2d2f65;
      }
      path.stroke {
        stroke: #2d2f65;
      }
    `}
`;

export default Pin;
